/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap/tooltip/tooltip';
const styles_NgbTooltipWindow:any[] = ([] as any[]);
export const RenderType_NgbTooltipWindow:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_NgbTooltipWindow,data:{}});
export function View_NgbTooltipWindow_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),1,'div',[['class','tooltip-inner']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),i0.ɵncd((null as any),0),(_l()(),
      i0.ɵted((null as any),['\n    ']))],(null as any),(null as any));
}
export function View_NgbTooltipWindow_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ngb-tooltip-window',
      [['role','tooltip']],[[8,'className',0],[8,'id',0]],(null as any),(null as any),
      View_NgbTooltipWindow_0,RenderType_NgbTooltipWindow)),i0.ɵdid(49152,(null as any),
      0,i1.NgbTooltipWindow,([] as any[]),(null as any),(null as any))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = ('tooltip show tooltip-' + i0.ɵnov(_v,1).placement);
        const currVal_1:any = i0.ɵnov(_v,1).id;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
export const NgbTooltipWindowNgFactory:i0.ComponentFactory<i1.NgbTooltipWindow> = i0.ɵccf('ngb-tooltip-window',
    i1.NgbTooltipWindow,View_NgbTooltipWindow_Host_0,{placement:'placement',id:'id'},
    {},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvdG9vbHRpcC90b29sdGlwLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvdG9vbHRpcC90b29sdGlwLmQudHMiLCJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL0BuZy1ib290c3RyYXAvbmctYm9vdHN0cmFwL3Rvb2x0aXAvdG9vbHRpcC5kLnRzLk5nYlRvb2x0aXBXaW5kb3cuaHRtbCIsIm5nOi8vL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvdG9vbHRpcC90b29sdGlwLmQudHMuTmdiVG9vbHRpcFdpbmRvd19Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgY2xhc3M9XCJ0b29sdGlwLWlubmVyXCI+PG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PjwvZGl2PlxuICAgICIsIjxuZ2ItdG9vbHRpcC13aW5kb3c+PC9uZ2ItdG9vbHRpcC13aW5kb3c+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsMkNBQ0k7TUFBQTtNQUFBLG1EQUEyQixrQkFBK0I7YUFBQTs7O29CQ0Q5RDtNQUFBO3lEQUFBLFVBQUE7TUFBQTs7UUFBQTtRQUFBO1FBQUEsV0FBQSxtQkFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/@ng-bootstrap/ng-bootstrap/tooltip/tooltip.ngfactory.ts